/**
 * Slider initialization - Vanilla JS (jQuery removed)
 * Uses VanillaSlider for all carousel functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    initSliders();
});

function initSliders() {
    // Main slideshow
    initSlideshow();

    // Featured collection slider
    initFeaturedCollection();

    // Logo list slider
    initLogoList();

    // Testimonials slider
    initTestimonials();

    // Announcement bar slider
    initAnnouncement();

    // Collection list mobile slider
    initCollectionListMobile();

    // Image text slider
    initImageText();

    // Complementary products slider
    initComplementaryProducts();
}

// Main slideshow (hero banner)
function initSlideshow() {
    const slideshow = document.querySelector('.slick-Slideshow');
    if (!slideshow || slideshow.children.length <= 1) return;

    // Read data-slick attribute for settings
    let options = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        fade: true,
        arrows: false,
        dots: false,
        autoplay: false,
        autoplaySpeed: 5000,
        speed: 500,
        swipe: true
    };

    // Parse data-slick if present
    const dataSlick = slideshow.dataset.slick;
    if (dataSlick) {
        try {
            const parsed = JSON.parse(dataSlick);
            if (parsed.autoplay !== undefined) options.autoplay = parsed.autoplay;
            if (parsed.autoplaySpeed !== undefined) options.autoplaySpeed = parsed.autoplaySpeed;
            if (parsed.dots !== undefined) options.dots = parsed.dots;
        } catch (e) {}
    }

    new VanillaSlider(slideshow, options);
}

// Featured collection products slider
function initFeaturedCollection() {
    document.querySelectorAll('.featured_collection-slider').forEach(slider => {
        if (slider.children.length <= 4) return;

        new VanillaSlider(slider, {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: true,
            speed: 500,
            swipe: true,
            prevArrow: getArrowPrev(),
            nextArrow: getArrowNext(),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
}

// Logo list slider
function initLogoList() {
    document.querySelectorAll('.logo_list_slider').forEach(slider => {
        if (slider.children.length <= 5) return;

        new VanillaSlider(slider, {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: true,
            speed: 500,
            swipe: true,
            prevArrow: getArrowPrev(),
            nextArrow: getArrowNext(),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
}

// Testimonials slider
function initTestimonials() {
    document.querySelectorAll('.testimonials-slider').forEach(slider => {
        if (slider.children.length <= 1) return;

        new VanillaSlider(slider, {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 500,
            swipe: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
}

// Announcement bar slider
function initAnnouncement() {
    document.querySelectorAll('.announcement-1').forEach(slider => {
        if (slider.children.length <= 1) return;

        new VanillaSlider(slider, {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 500,
            swipe: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
}

// Collection list mobile slider
function initCollectionListMobile() {
    document.querySelectorAll('.collection-list.mobile-only').forEach(slider => {
        if (slider.children.length <= 2) return;

        new VanillaSlider(slider, {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: false,
            arrows: true,
            autoplay: false,
            speed: 500,
            swipe: true,
            prevArrow: getArrowPrev(),
            nextArrow: getArrowNext()
        });
    });
}

// Image text slider
function initImageText() {
    document.querySelectorAll('.img_text').forEach(slider => {
        if (slider.children.length <= 2) return;

        new VanillaSlider(slider, {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 500,
            swipe: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
}

// Complementary products slider
function initComplementaryProducts() {
    document.querySelectorAll('.complementary_product').forEach(slider => {
        if (slider.children.length <= 3) return;

        new VanillaSlider(slider, {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: true,
            speed: 500,
            swipe: true,
            prevArrow: getArrowPrev(),
            nextArrow: getArrowNext(),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
}

// Product recommendations slider (loaded via AJAX, init on window load)
window.addEventListener('load', function() {
    initProductRecommendations();
    initRecentlyViewed();
});

function initProductRecommendations() {
    document.querySelectorAll('.product-recommendations-slider').forEach(slider => {
        if (slider.children.length <= 4) return;

        new VanillaSlider(slider, {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: true,
            speed: 500,
            swipe: true,
            prevArrow: getArrowPrev(),
            nextArrow: getArrowNext(),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
}

// Recently viewed products slider
function initRecentlyViewed() {
    const recentlyViewed = document.querySelector('.recently_viewed');
    if (recentlyViewed) {
        recentlyViewed.style.display = 'none';
    }

    // Wait for recently viewed products to be loaded
    const checkInterval = setInterval(function() {
        const grid = document.querySelector('.recently-viewed-grid');
        if (grid && grid.children.length > 0) {
            clearInterval(checkInterval);

            if (recentlyViewed) {
                recentlyViewed.style.display = '';
            }

            if (grid.children.length > 4) {
                new VanillaSlider(grid, {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: true,
                    speed: 500,
                    swipe: true,
                    prevArrow: getArrowPrev('Prev Control'),
                    nextArrow: getArrowNext('Next Control'),
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }
        }
    }, 1000);

    // Clear interval after 10 seconds to avoid infinite loop
    setTimeout(function() {
        clearInterval(checkInterval);
    }, 10000);
}

// Arrow HTML helpers
function getArrowPrev(label) {
    label = label || 'Previous';
    return '<button class="slide-arrow prev-arrow" aria-label="' + label + '"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" viewBox="0 0 256 256"><g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"><path d="M 65.75 90 c 0.896 0 1.792 -0.342 2.475 -1.025 c 1.367 -1.366 1.367 -3.583 0 -4.949 L 29.2 45 L 68.225 5.975 c 1.367 -1.367 1.367 -3.583 0 -4.95 c -1.367 -1.366 -3.583 -1.366 -4.95 0 l -41.5 41.5 c -1.367 1.366 -1.367 3.583 0 4.949 l 41.5 41.5 C 63.958 89.658 64.854 90 65.75 90 z" fill="rgb(0,0,0)"/></g></svg></button>';
}

function getArrowNext(label) {
    label = label || 'Next';
    return '<button class="slide-arrow next-arrow" aria-label="' + label + '"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" viewBox="0 0 256 256"><g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"><path d="M 24.25 90 c -0.896 0 -1.792 -0.342 -2.475 -1.025 c -1.367 -1.366 -1.367 -3.583 0 -4.949 L 60.8 45 L 21.775 5.975 c -1.367 -1.367 -1.367 -3.583 0 -4.95 c 1.367 -1.366 3.583 -1.366 4.95 0 l 41.5 41.5 c 1.367 1.366 1.367 3.583 0 4.949 l -41.5 41.5 C 26.042 89.658 25.146 90 24.25 90 z" fill="rgb(0,0,0)"/></g></svg></button>';
}

// Re-initialize on Shopify section load (theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
        initSliders();
    });
}
